export function deepFind(obj, path, defaultValue = undefined) {
  const paths = path.split(".");
  let current = obj;
  let i;
  if (obj === null || obj === undefined) {
    return defaultValue;
  }

  for (i = 0; i < paths.length; i += 1) {
    if (!current || current[paths[i]] === undefined) {
      return defaultValue;
    }
    current = current[paths[i]];
  }
  return current;
}
